import { GridColDef } from "@mui/x-data-grid";//GridValueGetterParams

export const colleaguesColumns: GridColDef[] = [
  { field: "id", headerName: "ID", width: 160 },
  // {
  //   field: "displayName",
  //   headerName: "Display Name",
  //   width: 180,
  // },

  {
    field: "username",
    headerName: "Username",
    width: 130,
  },
  {
    field: "email",
    headerName: "Email",
    width: 200,
  },
  {
    field: "role_title",
    headerName: "Role",
    width: 160,
    valueGetter: (params) => {
      if (params.row.role_title) return params.row.role_title;
      const role = params.row.role;
      if (role) {
        return role
          .split('_')
          .map((part: string) => part.charAt(0).toUpperCase() + part.slice(1))
          .join(' ');
      }
      const r = params.row.roles?.[0];
      if (!r) return '—';
      return r.replace('ROLE_', '').replace(/_/g, ' ').toLowerCase()
        .replace(/\b\w/g, (c: string) => c.toUpperCase());
    },
  },
  {
    field: "status",
    headerName: "Status",
    width: 100,
  },
  {
    field: "address",
    headerName: "Address",
    width: 170,
    // renderCell: (params: GridValueGetterParams) => {
    //   return (<span>{`${params.row.address}, ${params.row.country}`}</span>);
    // },
  },
];
